import React from 'react';

const styles = {
  container: {
    backgroundColor: 'var(--tg-theme-secondary-bg-color, #f5f5f5)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid var(--tg-theme-hint-color, #e0e0e0)',
  },
  image: {
    width: '100%',
    height: '180px',
    objectFit: 'cover',
    backgroundColor: 'var(--tg-theme-secondary-bg-color, #f0f0f0)',
  },
  imagePlaceholder: {
    width: '100%',
    height: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--tg-theme-secondary-bg-color, #f0f0f0)',
    fontSize: '40px',
  },
  body: {
    padding: '12px',
  },
  title: {
    fontSize: '16px',
    fontWeight: '600',
    color: 'var(--tg-theme-text-color, #000)',
    marginBottom: '6px',
    lineHeight: 1.3,
  },
  description: {
    fontSize: '13px',
    color: 'var(--tg-theme-hint-color, #8e8e93)',
    marginBottom: '8px',
    lineHeight: 1.4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
  },
  url: {
    fontSize: '12px',
    color: 'var(--tg-theme-link-color, #007aff)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  loading: {
    padding: '24px',
    textAlign: 'center',
    color: 'var(--tg-theme-hint-color, #8e8e93)',
    fontSize: '14px',
  },
  error: {
    padding: '16px',
    color: '#ff3b30',
    fontSize: '14px',
    textAlign: 'center',
  },
  skeleton: {
    backgroundColor: 'var(--tg-theme-hint-color, #e0e0e0)',
    borderRadius: '4px',
    marginBottom: '8px',
    animation: 'pulse 1.5s ease-in-out infinite',
  },
};

export default function ParsePreview({ parsed, loading, error, url }) {
  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.imagePlaceholder}>🔍</div>
        <div style={styles.body}>
          <div style={{ ...styles.skeleton, height: '18px', width: '80%' }} />
          <div style={{ ...styles.skeleton, height: '13px', width: '100%' }} />
          <div style={{ ...styles.skeleton, height: '13px', width: '60%' }} />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.container}>
        <div style={{ ...styles.error, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', padding: '20px' }}>
          <span style={{ fontSize: '32px' }}>🖼️</span>
          <span>Превью недоступно для этого сайта</span>
        </div>
      </div>
    );
  }

  if (!parsed) {
    return null;
  }

  const hostname = (() => {
    try {
      return new URL(parsed.url || url || '').hostname.replace(/^www\./, '');
    } catch {
      return parsed.url || url || '';
    }
  })();

  return (
    <div style={styles.container}>
      {parsed.image_url ? (
        <img
          src={parsed.image_url}
          alt={parsed.title || 'Превью'}
          style={styles.image}
          onError={(e) => {
            e.target.parentNode.insertBefore(
              Object.assign(document.createElement('div'), {
                style: `width:100%;height:80px;display:flex;align-items:center;justify-content:center;background:var(--tg-theme-secondary-bg-color,#f0f0f0);font-size:32px`,
                textContent: '🎁',
              }),
              e.target
            );
            e.target.remove();
          }}
        />
      ) : (
        <div style={styles.imagePlaceholder}>🎁</div>
      )}

      <div style={styles.body}>
        {parsed.title && <div style={styles.title}>{parsed.title}</div>}
        {parsed.description && (
          <div style={styles.description}>{parsed.description}</div>
        )}
        <div style={styles.url}>{hostname}</div>
      </div>
    </div>
  );
}
